const FullScreenOff = () => (
  <>
    <path
      fill="currentColor"
      d="M8.75 6.25a2.5 2.5 0 0 1-2.5 2.5H4.5a.5.5 0 0 1 0-1h1.75a1.5 1.5 0 0 0 1.5-1.5V4.5a.5.5 0 0 1 1 0zM7.75 19.5a.5.5 0 0 0 1 0v-1.75a2.5 2.5 0 0 0-2.5-2.5H4.5a.5.5 0 0 0 0 1h1.75a1.5 1.5 0 0 1 1.5 1.5zM15.25 19.5a.5.5 0 0 0 1 0v-1.75a1.5 1.5 0 0 1 1.5-1.5h1.75a.5.5 0 0 0 0-1h-1.75a2.5 2.5 0 0 0-2.5 2.5zM19.5 8.75a.5.5 0 0 0 0-1h-1.75a1.5 1.5 0 0 1-1.5-1.5V4.5a.5.5 0 0 0-1 0v1.75a2.5 2.5 0 0 0 2.5 2.5z"
    />
  </>
)
export default FullScreenOff
